// extracted by mini-css-extract-plugin
export var active = "DesktopCard-module--active--d8281";
export var card = "DesktopCard-module--card--e5c66";
export var content = "DesktopCard-module--content--3583b";
export var description = "DesktopCard-module--description--75277";
export var fadeInAnimation = "DesktopCard-module--fadeInAnimation--70158";
export var image = "DesktopCard-module--image--4a2cd";
export var link = "DesktopCard-module--link--179a7";
export var list = "DesktopCard-module--list--79067";
export var picture = "DesktopCard-module--picture--31dce";
export var smallTitle = "DesktopCard-module--smallTitle--06bea";
export var text = "DesktopCard-module--text--a5db2";
export var title = "DesktopCard-module--title--1cb4b";
export var withTransition = "DesktopCard-module--withTransition--4fe7d";